<template>
  <div class="invoice-create-page">
    <!--  credit form component -->
    <InvoiceForm
      page="create"
      :submitted="submitted"
      :duplicatecode="duplicatecode"
      v-on:FormUpdate="FormUpdate = 1"
      v-on:onSubmit="onSubmit($event)"
    ></InvoiceForm>
  </div>
</template>

<script>
import InvoiceForm from "@/components/Form/Amc/AmcInvoiceForm"; // credit form for create and update
import store from "@/store/index"; // vuex store fucntion
import { notificationMixin } from "@/mixins/notification"; // global fucntion for calling notification
import { mapState } from "vuex"; // get data set in the state in vuex

export default {
  name: "AmcInvoice",
  mixins: [notificationMixin], // call the glbal mixin fucntion
  components: {
    InvoiceForm
  },
  data() {
    return {
      FormUpdate: 0,
      duplicatecode: false,
      submitted: false,
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center" // notification design class
    };
  },
  methods: {
    onSubmit(ev) {
      this.submitted = true;

      this.$store
        .dispatch("invoice/createList", ev.data)
        .then(() => {
          this.FormUpdate = 0; // to hide before route leave confirmation message
          var message, type;
          if (this.code == 200) {
            type = "success";
            //  show if invoice successfully created
            message = "New Invoice Note has been created successfully!";

             if (ev.pageredirect == "payment") {
              this.$router.push({
                name: "InvoicePayment",
                params: {
                  id: this.updated_id
                }
              });
            } else if(ev.pageredirect != "payment"&&this. RoutePermission(false, '', 'invoice', 'invoice', 'index')){
              this.$router.push({
                name: "InvoiceView",
                params: {
                  id: this.updated_id
                }
              });
            } 
             else{
               this.$router.push({
                name: "AmcContractView",
                params:{
                  id:this.$route.params.id
                }
           })
          } 
            window.Messenger().post({
              extraClasses:
                "messenger-fixed messenger-on-top messenger-on-center",
              message: message,
              type: type,
              showCloseButton: true
            });
          } else {
            this.duplicatecode = true;
            this.submitted = false;
          }
          //  code for notificatin display
        })
        .catch(() => {});
    }
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    store
      .dispatch(
        "sales/fetchSalesDetails",
        JSON.stringify({
          type: "invoice"
        })
      )
      .then(() => {
        next();
      });
  },
  beforeRouteLeave(routeTo, routeFrom, next) {
    //  alert message before leaving route to confirm unsave the changes
    if (this.FormUpdate == 1) {
      //  alert message to confirm
      const answer = window.confirm(
        "Do you really want to leave? you have unsaved changes!"
      );
      //  if okay move to next route
      if (answer) {
        next();
      } else {
        //  stay on the page
        next(false);
      }
    } else {
      //  move to the route if they had not done any changes
      next();
    }
  },
  updated: function() {},
  created() {
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air"
    };
  },
  computed: {
    // mix this into the outer object with the object spread operator
    ...mapState({
      code: state => state.invoice.code,
      updated_id: state => state.invoice.updated_id
    })
  }
};
</script> 

<style>
</style>
